import React, { useMemo, useState } from "react";
import useMethods from "use-methods";
import _ from "lodash";
import AdminLayout from "../../template/admin.layout";
import TableListTemplate, {
  getTableListMethods,
} from "../../components/table-list-page.template";
import { useTableListPage } from "../../../../../hooks/useTableListPage";
import Datatable from "../../components/datatable/datatable";
import { useGetSponsorsList } from "../../../../../services/microservice/admin/sponsors/use-sponsors-admin";
import { ISponsor } from "../../../../../services/microservice/admin/types/admin.types";
import Chip from "../../../../../components/chip/chip";

const initialState: any = {
  filters: {},
  count: 0,
  currentPage: 0,
  perPage: 10,
  perPageOptions: [10, 20, 30],
};

const methods = (state: any) => ({
  ...getTableListMethods(state),
});

const AgentSponsorListAdminPage = () => {
  const [state, stateMethods] = useMethods(methods, initialState);
  const { data, isLoading } = useGetSponsorsList();

  const { updateCount } = stateMethods;

  const headCells = useMemo(
    () => [
      {
        id: "name",
        numeric: false,
        disablePadding: true,
        Header: "Nombre",
        accessor: (d: ISponsor) => `${d.name}`,
      },
      {
        id: "isActive",
        numeric: true,
        disablePadding: false,
        Header: "Activo",
        accessor: (d: ISponsor) => <Chip isActive={d.isActive} />,
      },
      {
        id: "dobleAuth",
        numeric: true,
        disablePadding: false,
        Header: "Doble factor de autenticación",
        accessor: (d: ISponsor) => <Chip isActive={d.dobleAuth} />,
      },
    ],
    [state.currentPage, state.perPage],
  );

  const rowsData = useMemo(() => {
    if (!data?.data.sponsors) return [];
    return data.data.sponsors.slice(
      state.currentPage * state.perPage,
      state.currentPage * state.perPage + state.perPage,
    );
  }, [data?.data.sponsors, state.currentPage, state.perPage]);

  useTableListPage({
    state,
    count: data?.data?.sponsors.length,
    updateCount,
    refetch: () => {},
  });

  return (
    <AdminLayout>
      <div className="mt-28 w-full">
        <TableListTemplate
          isLoading={isLoading}
          isEmpty={_.isEmpty(data?.data)}
          title={
            <div className="flew-row flex h-full w-full items-center justify-between">
              <div>Sponsors</div>
            </div>
          }
          table={<Datatable data={rowsData} columns={headCells} stickyHeader />}
          tableListMethods={stateMethods}
          tableListState={state}
        />
      </div>
    </AdminLayout>
  );
};

export default AgentSponsorListAdminPage;
